// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/log.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { DenseTimeSeriesChart } from "../../chart/v1/densetimeserieschart_pb";
import { file_chalk_chart_v1_densetimeserieschart } from "../../chart/v1/densetimeserieschart_pb";
import type { AggregateOptions, AggregateTable, Aggregation, AggregationFunction, RateOptions } from "../../searchaggregates/v1/aggregation_pb";
import { file_chalk_searchaggregates_v1_aggregation } from "../../searchaggregates/v1/aggregation_pb";
import type { StatisticResult } from "./chart_pb";
import { file_chalk_server_v1_chart } from "./chart_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/log.proto.
 */
export const file_chalk_server_v1_log: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_chart_v1_densetimeserieschart, file_chalk_searchaggregates_v1_aggregation, file_chalk_server_v1_chart, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.LogEntry
 */
export type LogEntry = Message<"chalk.server.v1.LogEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string severity = 2;
   */
  severity?: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 3;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: optional string function_name = 5;
   */
  functionName?: string;

  /**
   * @generated from field: optional string operation_id = 6;
   */
  operationId?: string;

  /**
   * @generated from field: optional string logger_name = 7;
   */
  loggerName?: string;

  /**
   * @generated from field: optional string agent_id = 8;
   */
  agentId?: string;

  /**
   * @generated from field: optional string operation_producer = 9;
   */
  operationProducer?: string;

  /**
   * @generated from field: optional bool is_user_logger = 10;
   */
  isUserLogger?: boolean;

  /**
   * @generated from field: map<string, string> labels = 11;
   */
  labels: { [key: string]: string };

  /**
   * @generated from field: optional string trace_id = 12;
   */
  traceId?: string;

  /**
   * @generated from field: optional string span_id = 13;
   */
  spanId?: string;
};

/**
 * Describes the message chalk.server.v1.LogEntry.
 * Use `create(LogEntrySchema)` to create a new message.
 */
export const LogEntrySchema: GenMessage<LogEntry> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 0);

/**
 * @generated from message chalk.server.v1.AccessLogEntry
 */
export type AccessLogEntry = Message<"chalk.server.v1.AccessLogEntry"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: string trace_id = 2;
   */
  traceId: string;

  /**
   * @generated from field: string authority = 3;
   */
  authority: string;

  /**
   * @generated from field: uint64 duration = 4;
   */
  duration: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 5;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: string upstream_host = 6;
   */
  upstreamHost: string;

  /**
   * @generated from field: string downstream_remote_address = 7;
   */
  downstreamRemoteAddress: string;

  /**
   * @generated from field: string environment_id = 8;
   */
  environmentId: string;

  /**
   * @generated from field: string path = 9;
   */
  path: string;

  /**
   * HTTP response code (e.g., "200", "503")
   *
   * @generated from field: string response_code = 10;
   */
  responseCode: string;

  /**
   * gRPC status number (0-16)
   *
   * @generated from field: optional int32 grpc_status_number = 11;
   */
  grpcStatusNumber?: number;

  /**
   * gRPC status string (e.g., "OK", "CANCELLED")
   *
   * @generated from field: optional string grpc_status = 12;
   */
  grpcStatus?: string;

  /**
   * @generated from field: map<string, string> attributes = 13;
   */
  attributes: { [key: string]: string };
};

/**
 * Describes the message chalk.server.v1.AccessLogEntry.
 * Use `create(AccessLogEntrySchema)` to create a new message.
 */
export const AccessLogEntrySchema: GenMessage<AccessLogEntry> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 1);

/**
 * @generated from message chalk.server.v1.SearchLogEntriesPageToken
 */
export type SearchLogEntriesPageToken = Message<"chalk.server.v1.SearchLogEntriesPageToken"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message chalk.server.v1.SearchLogEntriesPageToken.
 * Use `create(SearchLogEntriesPageTokenSchema)` to create a new message.
 */
export const SearchLogEntriesPageTokenSchema: GenMessage<SearchLogEntriesPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 2);

/**
 * @generated from message chalk.server.v1.SearchAccessLogEntriesPageToken
 */
export type SearchAccessLogEntriesPageToken = Message<"chalk.server.v1.SearchAccessLogEntriesPageToken"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message chalk.server.v1.SearchAccessLogEntriesPageToken.
 * Use `create(SearchAccessLogEntriesPageTokenSchema)` to create a new message.
 */
export const SearchAccessLogEntriesPageTokenSchema: GenMessage<SearchAccessLogEntriesPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 3);

/**
 * @generated from message chalk.server.v1.SearchLogEntriesRequest
 */
export type SearchLogEntriesRequest = Message<"chalk.server.v1.SearchLogEntriesRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: optional chalk.server.v1.SearchLogEntriesPageToken page_token = 2;
   */
  pageToken?: SearchLogEntriesPageToken;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * Overrides the environment cluster for resource-scoped views.
   *
   * @generated from field: optional string cluster_id = 5;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.SearchLogEntriesRequest.
 * Use `create(SearchLogEntriesRequestSchema)` to create a new message.
 */
export const SearchLogEntriesRequestSchema: GenMessage<SearchLogEntriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 4);

/**
 * @generated from message chalk.server.v1.SearchLogEntriesResponse
 */
export type SearchLogEntriesResponse = Message<"chalk.server.v1.SearchLogEntriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.LogEntry log_entries = 1;
   */
  logEntries: LogEntry[];

  /**
   * @generated from field: optional chalk.server.v1.SearchLogEntriesPageToken next_page_token = 2;
   */
  nextPageToken?: SearchLogEntriesPageToken;

  /**
   * @generated from field: string logging_client = 3;
   */
  loggingClient: string;
};

/**
 * Describes the message chalk.server.v1.SearchLogEntriesResponse.
 * Use `create(SearchLogEntriesResponseSchema)` to create a new message.
 */
export const SearchLogEntriesResponseSchema: GenMessage<SearchLogEntriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 5);

/**
 * @generated from message chalk.server.v1.SearchAccessLogEntriesRequest
 */
export type SearchAccessLogEntriesRequest = Message<"chalk.server.v1.SearchAccessLogEntriesRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: optional chalk.server.v1.SearchAccessLogEntriesPageToken page_token = 2;
   */
  pageToken?: SearchAccessLogEntriesPageToken;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * When set, queries the scaling_group_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string scaling_group_id = 5;
   */
  scalingGroupId?: string;

  /**
   * When set, queries the container_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string container_id = 6;
   */
  containerId?: string;

  /**
   * @generated from field: optional string cluster_id = 7;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.SearchAccessLogEntriesRequest.
 * Use `create(SearchAccessLogEntriesRequestSchema)` to create a new message.
 */
export const SearchAccessLogEntriesRequestSchema: GenMessage<SearchAccessLogEntriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 6);

/**
 * @generated from message chalk.server.v1.SearchAccessLogEntriesResponse
 */
export type SearchAccessLogEntriesResponse = Message<"chalk.server.v1.SearchAccessLogEntriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.AccessLogEntry access_log_entries = 1;
   */
  accessLogEntries: AccessLogEntry[];

  /**
   * @generated from field: optional chalk.server.v1.SearchAccessLogEntriesPageToken next_page_token = 2;
   */
  nextPageToken?: SearchAccessLogEntriesPageToken;
};

/**
 * Describes the message chalk.server.v1.SearchAccessLogEntriesResponse.
 * Use `create(SearchAccessLogEntriesResponseSchema)` to create a new message.
 */
export const SearchAccessLogEntriesResponseSchema: GenMessage<SearchAccessLogEntriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 7);

/**
 * @generated from message chalk.server.v1.StreamSearchLogEntriesRequest
 */
export type StreamSearchLogEntriesRequest = Message<"chalk.server.v1.StreamSearchLogEntriesRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: optional chalk.server.v1.SearchLogEntriesPageToken page_token = 2;
   */
  pageToken?: SearchLogEntriesPageToken;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.StreamSearchLogEntriesRequest.
 * Use `create(StreamSearchLogEntriesRequestSchema)` to create a new message.
 */
export const StreamSearchLogEntriesRequestSchema: GenMessage<StreamSearchLogEntriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 8);

/**
 * Each streamed message carries a chunk of log_entries. The final message
 * in the stream may set next_page_token; logging_client is set on the first
 * streamed message.
 *
 * @generated from message chalk.server.v1.StreamSearchLogEntriesResponse
 */
export type StreamSearchLogEntriesResponse = Message<"chalk.server.v1.StreamSearchLogEntriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.LogEntry log_entries = 1;
   */
  logEntries: LogEntry[];

  /**
   * @generated from field: optional chalk.server.v1.SearchLogEntriesPageToken next_page_token = 2;
   */
  nextPageToken?: SearchLogEntriesPageToken;

  /**
   * @generated from field: string logging_client = 3;
   */
  loggingClient: string;
};

/**
 * Describes the message chalk.server.v1.StreamSearchLogEntriesResponse.
 * Use `create(StreamSearchLogEntriesResponseSchema)` to create a new message.
 */
export const StreamSearchLogEntriesResponseSchema: GenMessage<StreamSearchLogEntriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 9);

/**
 * @generated from message chalk.server.v1.StreamSearchAccessLogEntriesRequest
 */
export type StreamSearchAccessLogEntriesRequest = Message<"chalk.server.v1.StreamSearchAccessLogEntriesRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: optional chalk.server.v1.SearchAccessLogEntriesPageToken page_token = 2;
   */
  pageToken?: SearchAccessLogEntriesPageToken;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * When set, queries the scaling_group_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string scaling_group_id = 5;
   */
  scalingGroupId?: string;

  /**
   * When set, queries the container_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string container_id = 6;
   */
  containerId?: string;
};

/**
 * Describes the message chalk.server.v1.StreamSearchAccessLogEntriesRequest.
 * Use `create(StreamSearchAccessLogEntriesRequestSchema)` to create a new message.
 */
export const StreamSearchAccessLogEntriesRequestSchema: GenMessage<StreamSearchAccessLogEntriesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 10);

/**
 * Each streamed message carries a chunk of access_log_entries. The final
 * message in the stream may set next_page_token.
 *
 * @generated from message chalk.server.v1.StreamSearchAccessLogEntriesResponse
 */
export type StreamSearchAccessLogEntriesResponse = Message<"chalk.server.v1.StreamSearchAccessLogEntriesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.AccessLogEntry access_log_entries = 1;
   */
  accessLogEntries: AccessLogEntry[];

  /**
   * @generated from field: optional chalk.server.v1.SearchAccessLogEntriesPageToken next_page_token = 2;
   */
  nextPageToken?: SearchAccessLogEntriesPageToken;
};

/**
 * Describes the message chalk.server.v1.StreamSearchAccessLogEntriesResponse.
 * Use `create(StreamSearchAccessLogEntriesResponseSchema)` to create a new message.
 */
export const StreamSearchAccessLogEntriesResponseSchema: GenMessage<StreamSearchAccessLogEntriesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 11);

/**
 * @generated from message chalk.server.v1.SearchLogEntriesAggregatedRequest
 */
export type SearchLogEntriesAggregatedRequest = Message<"chalk.server.v1.SearchLogEntriesAggregatedRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration window_period = 4;
   */
  windowPeriod?: Duration;

  /**
   * Superseded by options.group_by / options.limit, which win when `options` is set; still read so a
   * client predating `options` keeps working.
   *
   * @generated from field: repeated string facets = 5 [deprecated = true];
   * @deprecated
   */
  facets: string[];

  /**
   * @generated from field: optional int32 limit = 6 [deprecated = true];
   * @deprecated
   */
  limit?: number;

  /**
   * Non-COUNT is ClickHouse-only, and otel_logs has no numeric column, so only COUNT UNIQUE applies.
   * Unset group_by → severity.
   *
   * @generated from field: chalk.searchaggregates.v1.AggregateOptions options = 7;
   */
  options?: AggregateOptions;

  /**
   * @generated from field: optional string cluster_id = 8;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.SearchLogEntriesAggregatedRequest.
 * Use `create(SearchLogEntriesAggregatedRequestSchema)` to create a new message.
 */
export const SearchLogEntriesAggregatedRequestSchema: GenMessage<SearchLogEntriesAggregatedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 12);

/**
 * @generated from message chalk.server.v1.SearchLogEntriesAggregatedResponse
 */
export type SearchLogEntriesAggregatedResponse = Message<"chalk.server.v1.SearchLogEntriesAggregatedResponse"> & {
  /**
   * @generated from field: chalk.chart.v1.DenseTimeSeriesChart chart = 1;
   */
  chart?: DenseTimeSeriesChart;
};

/**
 * Describes the message chalk.server.v1.SearchLogEntriesAggregatedResponse.
 * Use `create(SearchLogEntriesAggregatedResponseSchema)` to create a new message.
 */
export const SearchLogEntriesAggregatedResponseSchema: GenMessage<SearchLogEntriesAggregatedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 13);

/**
 * @generated from message chalk.server.v1.GetLogFacetsRequest
 */
export type GetLogFacetsRequest = Message<"chalk.server.v1.GetLogFacetsRequest"> & {
  /**
   * @generated from field: optional string cluster_id = 1;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetLogFacetsRequest.
 * Use `create(GetLogFacetsRequestSchema)` to create a new message.
 */
export const GetLogFacetsRequestSchema: GenMessage<GetLogFacetsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 14);

/**
 * @generated from message chalk.server.v1.LogFacet
 */
export type LogFacet = Message<"chalk.server.v1.LogFacet"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.LogFacetType facet_type = 3;
   */
  facetType: LogFacetType;

  /**
   * Whether this facet may be used as a COUNT BY / chart group-by dimension.
   *
   * @generated from field: bool groupable = 4;
   */
  groupable: boolean;

  /**
   * Aggregation functions this facet's column supports as a Get(Access)LogAggregates measure
   * (empty → not a measure), so the client offers only valid functions per facet.
   *
   * @generated from field: repeated chalk.searchaggregates.v1.AggregationFunction supported_aggregations = 5;
   */
  supportedAggregations: AggregationFunction[];
};

/**
 * Describes the message chalk.server.v1.LogFacet.
 * Use `create(LogFacetSchema)` to create a new message.
 */
export const LogFacetSchema: GenMessage<LogFacet> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 15);

/**
 * @generated from message chalk.server.v1.GetLogFacetsResponse
 */
export type GetLogFacetsResponse = Message<"chalk.server.v1.GetLogFacetsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.LogFacet facets = 1;
   */
  facets: LogFacet[];
};

/**
 * Describes the message chalk.server.v1.GetLogFacetsResponse.
 * Use `create(GetLogFacetsResponseSchema)` to create a new message.
 */
export const GetLogFacetsResponseSchema: GenMessage<GetLogFacetsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 16);

/**
 * @generated from message chalk.server.v1.GetLogFacetValuesRequest
 */
export type GetLogFacetValuesRequest = Message<"chalk.server.v1.GetLogFacetValuesRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: optional string query = 5;
   */
  query?: string;

  /**
   * Count-table mode: keep empty values as a "(none)" row and append an "(other)" row summing
   * everything beyond the limit, so every log is accounted for. Off for the facets sidebar.
   *
   * @generated from field: optional bool include_synthetic_rows = 6;
   */
  includeSyntheticRows?: boolean;

  /**
   * Non-empty → count value combinations across these facets (in order); `path` is ignored. Empty → single-`path`.
   *
   * @generated from field: repeated string facets = 7;
   */
  facets: string[];

  /**
   * @generated from field: optional string cluster_id = 8;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetLogFacetValuesRequest.
 * Use `create(GetLogFacetValuesRequestSchema)` to create a new message.
 */
export const GetLogFacetValuesRequestSchema: GenMessage<GetLogFacetValuesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 17);

/**
 * @generated from message chalk.server.v1.LogFacetValue
 */
export type LogFacetValue = Message<"chalk.server.v1.LogFacetValue"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint;

  /**
   * One value per requested facet, index-aligned to request `facets`. Empty in single-`path` mode (scalar `value` set instead).
   *
   * @generated from field: repeated string values = 3;
   */
  values: string[];
};

/**
 * Describes the message chalk.server.v1.LogFacetValue.
 * Use `create(LogFacetValueSchema)` to create a new message.
 */
export const LogFacetValueSchema: GenMessage<LogFacetValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 18);

/**
 * @generated from message chalk.server.v1.GetLogFacetValuesResponse
 */
export type GetLogFacetValuesResponse = Message<"chalk.server.v1.GetLogFacetValuesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.LogFacetValue values = 1;
   */
  values: LogFacetValue[];
};

/**
 * Describes the message chalk.server.v1.GetLogFacetValuesResponse.
 * Use `create(GetLogFacetValuesResponseSchema)` to create a new message.
 */
export const GetLogFacetValuesResponseSchema: GenMessage<GetLogFacetValuesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 19);

/**
 * @generated from message chalk.server.v1.SearchAccessLogEntriesAggregatedRequest
 */
export type SearchAccessLogEntriesAggregatedRequest = Message<"chalk.server.v1.SearchAccessLogEntriesAggregatedRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration window_period = 4;
   */
  windowPeriod?: Duration;

  /**
   * When set, queries the scaling_group_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string scaling_group_id = 5;
   */
  scalingGroupId?: string;

  /**
   * When set, queries the container_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string container_id = 6;
   */
  containerId?: string;

  /**
   * Superseded by options.group_by / options.limit, which win when `options` is set; still read so a
   * client predating `options` keeps working.
   *
   * @generated from field: repeated string facets = 7 [deprecated = true];
   * @deprecated
   */
  facets: string[];

  /**
   * @generated from field: optional int32 limit = 8 [deprecated = true];
   * @deprecated
   */
  limit?: number;

  /**
   * Non-COUNT is ClickHouse-only. Unset group_by → status code.
   *
   * @generated from field: chalk.searchaggregates.v1.AggregateOptions options = 9;
   */
  options?: AggregateOptions;

  /**
   * @generated from field: optional string cluster_id = 10;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.SearchAccessLogEntriesAggregatedRequest.
 * Use `create(SearchAccessLogEntriesAggregatedRequestSchema)` to create a new message.
 */
export const SearchAccessLogEntriesAggregatedRequestSchema: GenMessage<SearchAccessLogEntriesAggregatedRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 20);

/**
 * @generated from message chalk.server.v1.SearchAccessLogEntriesAggregatedResponse
 */
export type SearchAccessLogEntriesAggregatedResponse = Message<"chalk.server.v1.SearchAccessLogEntriesAggregatedResponse"> & {
  /**
   * @generated from field: chalk.chart.v1.DenseTimeSeriesChart chart = 1;
   */
  chart?: DenseTimeSeriesChart;
};

/**
 * Describes the message chalk.server.v1.SearchAccessLogEntriesAggregatedResponse.
 * Use `create(SearchAccessLogEntriesAggregatedResponseSchema)` to create a new message.
 */
export const SearchAccessLogEntriesAggregatedResponseSchema: GenMessage<SearchAccessLogEntriesAggregatedResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 21);

/**
 * @generated from message chalk.server.v1.GetAccessLogFacetsRequest
 */
export type GetAccessLogFacetsRequest = Message<"chalk.server.v1.GetAccessLogFacetsRequest"> & {
  /**
   * @generated from field: optional string cluster_id = 1;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetAccessLogFacetsRequest.
 * Use `create(GetAccessLogFacetsRequestSchema)` to create a new message.
 */
export const GetAccessLogFacetsRequestSchema: GenMessage<GetAccessLogFacetsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 22);

/**
 * @generated from message chalk.server.v1.GetAccessLogFacetsResponse
 */
export type GetAccessLogFacetsResponse = Message<"chalk.server.v1.GetAccessLogFacetsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.LogFacet facets = 1;
   */
  facets: LogFacet[];
};

/**
 * Describes the message chalk.server.v1.GetAccessLogFacetsResponse.
 * Use `create(GetAccessLogFacetsResponseSchema)` to create a new message.
 */
export const GetAccessLogFacetsResponseSchema: GenMessage<GetAccessLogFacetsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 23);

/**
 * @generated from message chalk.server.v1.GetAccessLogFacetValuesRequest
 */
export type GetAccessLogFacetValuesRequest = Message<"chalk.server.v1.GetAccessLogFacetValuesRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: optional string query = 5;
   */
  query?: string;

  /**
   * When set, queries the scaling_group_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string scaling_group_id = 6;
   */
  scalingGroupId?: string;

  /**
   * When set, queries the container_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string container_id = 7;
   */
  containerId?: string;

  /**
   * Count-table mode: keep empty values as a "(none)" row and append an "(other)" row summing
   * everything beyond the limit. Off for the facets sidebar.
   *
   * @generated from field: optional bool include_synthetic_rows = 8;
   */
  includeSyntheticRows?: boolean;

  /**
   * Multi-facet COUNT BY: LogFacet.paths to group by (non-empty → `path` ignored, one `values` per facet per row).
   *
   * @generated from field: repeated string facets = 9;
   */
  facets: string[];

  /**
   * @generated from field: optional string cluster_id = 10;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetAccessLogFacetValuesRequest.
 * Use `create(GetAccessLogFacetValuesRequestSchema)` to create a new message.
 */
export const GetAccessLogFacetValuesRequestSchema: GenMessage<GetAccessLogFacetValuesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 24);

/**
 * @generated from message chalk.server.v1.GetAccessLogFacetValuesResponse
 */
export type GetAccessLogFacetValuesResponse = Message<"chalk.server.v1.GetAccessLogFacetValuesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.LogFacetValue values = 1;
   */
  values: LogFacetValue[];
};

/**
 * Describes the message chalk.server.v1.GetAccessLogFacetValuesResponse.
 * Use `create(GetAccessLogFacetValuesResponseSchema)` to create a new message.
 */
export const GetAccessLogFacetValuesResponseSchema: GenMessage<GetAccessLogFacetValuesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 25);

/**
 * GetAccessLogAggregatesRequest computes arbitrary aggregations grouped by 0-3 access-log facets
 * (group-by dimensions are LogFacet.paths).
 *
 * @generated from message chalk.server.v1.GetAccessLogAggregatesRequest
 */
export type GetAccessLogAggregatesRequest = Message<"chalk.server.v1.GetAccessLogAggregatesRequest"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * Faceted-search query string; scopes the aggregated access logs.
   *
   * @generated from field: optional string query = 3;
   */
  query?: string;

  /**
   * When set, queries the scaling_group_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string scaling_group_id = 4;
   */
  scalingGroupId?: string;

  /**
   * When set, queries the container_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string container_id = 5;
   */
  containerId?: string;

  /**
   * @generated from field: chalk.searchaggregates.v1.AggregateOptions options = 6;
   */
  options?: AggregateOptions;

  /**
   * @generated from field: optional string cluster_id = 7;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetAccessLogAggregatesRequest.
 * Use `create(GetAccessLogAggregatesRequestSchema)` to create a new message.
 */
export const GetAccessLogAggregatesRequestSchema: GenMessage<GetAccessLogAggregatesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 26);

/**
 * GetAccessLogAggregatesResponse returns the ranked aggregate table.
 *
 * @generated from message chalk.server.v1.GetAccessLogAggregatesResponse
 */
export type GetAccessLogAggregatesResponse = Message<"chalk.server.v1.GetAccessLogAggregatesResponse"> & {
  /**
   * @generated from field: chalk.searchaggregates.v1.AggregateTable table = 1;
   */
  table?: AggregateTable;
};

/**
 * Describes the message chalk.server.v1.GetAccessLogAggregatesResponse.
 * Use `create(GetAccessLogAggregatesResponseSchema)` to create a new message.
 */
export const GetAccessLogAggregatesResponseSchema: GenMessage<GetAccessLogAggregatesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 27);

/**
 * GetLogAggregatesRequest computes aggregations grouped by 0-3 log facets (LogFacet.paths). otel_logs
 * has no numeric column, so numeric functions are InvalidArgument here.
 *
 * @generated from message chalk.server.v1.GetLogAggregatesRequest
 */
export type GetLogAggregatesRequest = Message<"chalk.server.v1.GetLogAggregatesRequest"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * Faceted-search query string; scopes the aggregated logs.
   *
   * @generated from field: optional string query = 3;
   */
  query?: string;

  /**
   * @generated from field: chalk.searchaggregates.v1.AggregateOptions options = 4;
   */
  options?: AggregateOptions;

  /**
   * @generated from field: optional string cluster_id = 5;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetLogAggregatesRequest.
 * Use `create(GetLogAggregatesRequestSchema)` to create a new message.
 */
export const GetLogAggregatesRequestSchema: GenMessage<GetLogAggregatesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 28);

/**
 * GetLogAggregatesResponse returns the ranked aggregate table.
 *
 * @generated from message chalk.server.v1.GetLogAggregatesResponse
 */
export type GetLogAggregatesResponse = Message<"chalk.server.v1.GetLogAggregatesResponse"> & {
  /**
   * @generated from field: chalk.searchaggregates.v1.AggregateTable table = 1;
   */
  table?: AggregateTable;
};

/**
 * Describes the message chalk.server.v1.GetLogAggregatesResponse.
 * Use `create(GetLogAggregatesResponseSchema)` to create a new message.
 */
export const GetLogAggregatesResponseSchema: GenMessage<GetLogAggregatesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 29);

/**
 * Reduces the logs matching `query` in [start_time, end_time] to one scalar, for a statistic tile.
 *
 * @generated from message chalk.server.v1.GetLogStatRequest
 */
export type GetLogStatRequest = Message<"chalk.server.v1.GetLogStatRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * When set, also evaluate the window shifted back by this offset and return it as previous_value.
   * (end-start) compares against the immediately preceding window; a week/month against the same
   * window one week/month ago.
   *
   * @generated from field: optional google.protobuf.Duration comparison_lookback_offset = 4;
   */
  comparisonLookbackOffset?: Duration;

  /**
   * Unset is COUNT, the only function every logging backend serves; the rest are ClickHouse-only.
   *
   * @generated from field: optional chalk.searchaggregates.v1.Aggregation aggregation = 5;
   */
  aggregation?: Aggregation;

  /**
   * When set, reports a per-interval rate instead of the window total; COUNT and SUM only.
   *
   * @generated from field: optional chalk.searchaggregates.v1.RateOptions rate_options = 6;
   */
  rateOptions?: RateOptions;
};

/**
 * Describes the message chalk.server.v1.GetLogStatRequest.
 * Use `create(GetLogStatRequestSchema)` to create a new message.
 */
export const GetLogStatRequestSchema: GenMessage<GetLogStatRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 30);

/**
 * @generated from message chalk.server.v1.GetLogStatResponse
 */
export type GetLogStatResponse = Message<"chalk.server.v1.GetLogStatResponse"> & {
  /**
   * @generated from field: chalk.server.v1.StatisticResult result = 1;
   */
  result?: StatisticResult;
};

/**
 * Describes the message chalk.server.v1.GetLogStatResponse.
 * Use `create(GetLogStatResponseSchema)` to create a new message.
 */
export const GetLogStatResponseSchema: GenMessage<GetLogStatResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 31);

/**
 * Reduces the access logs matching `query` in [start_time, end_time] to one scalar, for a statistic
 * tile. Mirrors GetLogStat, which it parallels; Duration makes non-count measures useful here.
 *
 * @generated from message chalk.server.v1.GetAccessLogStatRequest
 */
export type GetAccessLogStatRequest = Message<"chalk.server.v1.GetAccessLogStatRequest"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * When set, also evaluate the window shifted back by this offset and return it as previous_value.
   *
   * @generated from field: optional google.protobuf.Duration comparison_lookback_offset = 4;
   */
  comparisonLookbackOffset?: Duration;

  /**
   * Unset is COUNT; anything else needs a measure the access-log facet registry advertises.
   *
   * @generated from field: optional chalk.searchaggregates.v1.Aggregation aggregation = 5;
   */
  aggregation?: Aggregation;

  /**
   * When set, queries the scaling_group_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string scaling_group_id = 6;
   */
  scalingGroupId?: string;

  /**
   * When set, queries the container_access_logs materialized view filtered by this ID.
   *
   * @generated from field: optional string container_id = 7;
   */
  containerId?: string;

  /**
   * When set, reports a per-interval rate instead of the window total; COUNT and SUM only.
   *
   * @generated from field: optional chalk.searchaggregates.v1.RateOptions rate_options = 8;
   */
  rateOptions?: RateOptions;
};

/**
 * Describes the message chalk.server.v1.GetAccessLogStatRequest.
 * Use `create(GetAccessLogStatRequestSchema)` to create a new message.
 */
export const GetAccessLogStatRequestSchema: GenMessage<GetAccessLogStatRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 32);

/**
 * @generated from message chalk.server.v1.GetAccessLogStatResponse
 */
export type GetAccessLogStatResponse = Message<"chalk.server.v1.GetAccessLogStatResponse"> & {
  /**
   * @generated from field: chalk.server.v1.StatisticResult result = 1;
   */
  result?: StatisticResult;
};

/**
 * Describes the message chalk.server.v1.GetAccessLogStatResponse.
 * Use `create(GetAccessLogStatResponseSchema)` to create a new message.
 */
export const GetAccessLogStatResponseSchema: GenMessage<GetAccessLogStatResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_log, 33);

/**
 * How a facet's values are interpreted: only LIST is enumerable (sidebar + value autocomplete); the
 * rest are filter-only search keys. RANGE is numeric (durations) and the anchor for future numeric
 * aggregations. Shared reference for the parallel KubeEventFacetType / SpanFacetType enums.
 *
 * @generated from enum chalk.server.v1.LogFacetType
 */
export enum LogFacetType {
  /**
   * @generated from enum value: LOG_FACET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * enumerable categorical (service, severity)
   *
   * @generated from enum value: LOG_FACET_TYPE_LIST = 1;
   */
  LIST = 1,

  /**
   * numeric/comparable (durations)
   *
   * @generated from enum value: LOG_FACET_TYPE_RANGE = 2;
   */
  RANGE = 2,

  /**
   * free-text substring (message)
   *
   * @generated from enum value: LOG_FACET_TYPE_TEXT = 3;
   */
  TEXT = 3,

  /**
   * opaque high-cardinality id (trace_id)
   *
   * @generated from enum value: LOG_FACET_TYPE_ID = 4;
   */
  ID = 4,
}

/**
 * Describes the enum chalk.server.v1.LogFacetType.
 */
export const LogFacetTypeSchema: GenEnum<LogFacetType> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_log, 0);

/**
 * @generated from service chalk.server.v1.LogSearchService
 */
export const LogSearchService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.SearchLogEntries
   */
  searchLogEntries: {
    methodKind: "unary";
    input: typeof SearchLogEntriesRequestSchema;
    output: typeof SearchLogEntriesResponseSchema;
  },
  /**
   * Server-streaming variant of SearchLogEntries. Each streamed
   * StreamSearchLogEntriesResponse carries a chunk of log_entries; the
   * final message may also carry next_page_token.
   *
   * @generated from rpc chalk.server.v1.LogSearchService.StreamSearchLogEntries
   */
  streamSearchLogEntries: {
    methodKind: "server_streaming";
    input: typeof StreamSearchLogEntriesRequestSchema;
    output: typeof StreamSearchLogEntriesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.SearchLogEntriesAggregated
   */
  searchLogEntriesAggregated: {
    methodKind: "unary";
    input: typeof SearchLogEntriesAggregatedRequestSchema;
    output: typeof SearchLogEntriesAggregatedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.GetLogFacets
   */
  getLogFacets: {
    methodKind: "unary";
    input: typeof GetLogFacetsRequestSchema;
    output: typeof GetLogFacetsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.GetLogFacetValues
   */
  getLogFacetValues: {
    methodKind: "unary";
    input: typeof GetLogFacetValuesRequestSchema;
    output: typeof GetLogFacetValuesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.SearchAccessLogEntries
   */
  searchAccessLogEntries: {
    methodKind: "unary";
    input: typeof SearchAccessLogEntriesRequestSchema;
    output: typeof SearchAccessLogEntriesResponseSchema;
  },
  /**
   * Server-streaming variant of SearchAccessLogEntries. Each streamed
   * StreamSearchAccessLogEntriesResponse carries a chunk of access_log_entries;
   * the final message may also carry next_page_token.
   *
   * @generated from rpc chalk.server.v1.LogSearchService.StreamSearchAccessLogEntries
   */
  streamSearchAccessLogEntries: {
    methodKind: "server_streaming";
    input: typeof StreamSearchAccessLogEntriesRequestSchema;
    output: typeof StreamSearchAccessLogEntriesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.SearchAccessLogEntriesAggregated
   */
  searchAccessLogEntriesAggregated: {
    methodKind: "unary";
    input: typeof SearchAccessLogEntriesAggregatedRequestSchema;
    output: typeof SearchAccessLogEntriesAggregatedResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.GetAccessLogFacets
   */
  getAccessLogFacets: {
    methodKind: "unary";
    input: typeof GetAccessLogFacetsRequestSchema;
    output: typeof GetAccessLogFacetsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.GetAccessLogFacetValues
   */
  getAccessLogFacetValues: {
    methodKind: "unary";
    input: typeof GetAccessLogFacetValuesRequestSchema;
    output: typeof GetAccessLogFacetValuesResponseSchema;
  },
  /**
   * GetAccessLogAggregates computes arbitrary aggregations (count distinct, sum/avg/min/max,
   * percentiles) grouped by 0-3 access-log facets.
   *
   * @generated from rpc chalk.server.v1.LogSearchService.GetAccessLogAggregates
   */
  getAccessLogAggregates: {
    methodKind: "unary";
    input: typeof GetAccessLogAggregatesRequestSchema;
    output: typeof GetAccessLogAggregatesResponseSchema;
  },
  /**
   * ClickHouse-only; other logging backends return FailedPrecondition.
   *
   * @generated from rpc chalk.server.v1.LogSearchService.GetLogAggregates
   */
  getLogAggregates: {
    methodKind: "unary";
    input: typeof GetLogAggregatesRequestSchema;
    output: typeof GetLogAggregatesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.GetLogStat
   */
  getLogStat: {
    methodKind: "unary";
    input: typeof GetLogStatRequestSchema;
    output: typeof GetLogStatResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.LogSearchService.GetAccessLogStat
   */
  getAccessLogStat: {
    methodKind: "unary";
    input: typeof GetAccessLogStatRequestSchema;
    output: typeof GetAccessLogStatResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_log, 0);

